import * as React from "react";
import copy from "copy-to-clipboard";
import { observer, inject } from "mobx-react";

import { CodeBtn, CouponContainer, InnerBox } from "./style";
import Loading from "../../../components/Loading";
import Toast from "../../../components/Toast";
import { LTReceiveToast } from "../../../components/LTReceiveToast";
import { CouponType } from "../../../services/banner";
import { TModuleWithImgProps } from "../../../services/playground";
import type { ReceiveCouponStore } from "store/coupon/ReceiveCoupon";
import { ReceivedCouponStatusEnum } from "utils/zeusFetch";
import { getLitbLangFn } from "utils/language/index";
import { GetReceiveCouponResp } from "utils/zeusFetch";
import { transformImageTights } from "utils/image";
import { getReceivedCouponIcon } from "views/utils/receiveCoupon";

export interface CouponProps extends TModuleWithImgProps {
	columnSize: number;
	coupons: RenderCoupon[];
	positionId: string;
	type: CouponType;
	spmClick: (index: number) => void;
	getCoupons: (code: string) => Promise<GetReceiveCouponResp>;
	receiveCoupon?: ReceiveCouponStore;
}
export interface RenderCoupon {
	img: string;
	code: string;
	width: number;
	height: number;
}
interface CouponState {
	showToast: boolean;
	status: number;
	type: CouponType;
	loadingMap: Record<string, boolean>;
}

@inject("receiveCoupon")
@observer
class CouponCode extends React.Component<CouponProps, CouponState> {
	constructor(props: CouponProps) {
		super(props);
		this.state = {
			showToast: false,
			status: -1,
			type: this.props?.type || CouponType.CopyCoupon,
			loadingMap: {},
		};
	}
	// 复制型优惠券
	onClickCopyBtn = (code: string) => {
		copy(code);
		this.setState(
			() => {
				return {
					showToast: true,
				};
			},
			() => {
				setTimeout(() => {
					this.setState(() => {
						return {
							showToast: false,
						};
					});
				}, 3000);
			},
		);
	};
	// 领取型优惠券
	onClickReceiveCoupon = async (code: string) => {
		try {
			this.setState({
				loadingMap: {
					...this.state.loadingMap,
					[code]: true,
				},
			});
			const resp = await this.props.getCoupons(code);
			this.setState(() => {
				return {
					showToast: resp.code === "1000000",
					status: resp.info?.status,
				};
			});
			await this.props.receiveCoupon?.updateCouponInfo(code);
		} finally {
			this.setState({
				loadingMap: {
					...this.state.loadingMap,
					[code]: false,
				},
			});
		}
	};
	renderCoupon = (coupons: RenderCoupon[]) => {
		return coupons.map((item: RenderCoupon, index) => {
			const imgUrl = transformImageTights(item.img);
			const hasReceived =
				this.state.type === CouponType.ReceiveCoupon &&
				this.props.receiveCoupon?.getCouponInfoByCampaignKey(item.code)?.status ===
					ReceivedCouponStatusEnum.OVERSTEP;
			const isLoading = this.state.type === CouponType.ReceiveCoupon && this.state.loadingMap[item.code];
			
			return (
				<CodeBtn
					key={`${item.code}_${index}`}
					imgUrl={imgUrl}
					onClick={() => {
						this.props.spmClick && this.props.spmClick(index);
						if (this.props.type === CouponType.CopyCoupon) {
							this.onClickCopyBtn(item.code);
						} else {
							if (isLoading) return;
							this.onClickReceiveCoupon(item.code);
						}
					}}>
					{isLoading ? <Loading /> : null}
					{hasReceived ? (
						<div className="receive-mask">
							<img
								className="receive-flag"
								src={transformImageTights(
									getReceivedCouponIcon(this.props.language),
								)}
								width={60}
								height={60}
							/>
						</div>
					) : null}
				</CodeBtn>
			);
		});
	};

	renderToast = () => {
		if (this.state.type === CouponType.CopyCoupon) {
			return (
				<Toast
					message={`${getLitbLangFn("Coupon successfully copied", this.props?.language)}`}
					height={64}
					width={512}
				/>
			);
		}
		return (
			<LTReceiveToast
				isMobile={false}
				status={this.state.status}
				lang={this.props.language}
				onClose={() => {
					this.setState({ showToast: false });
				}}
			/>
		);
	};

	render() {
		const { columnSize, coupons, positionId } = this.props;
		const { showToast } = this.state;
		if (!coupons || coupons.length === 0) {
			return null;
		}
		return (
			<CouponContainer id={positionId}>
				<InnerBox
					columnSize={columnSize}
					rows={Math.ceil(+this.props.coupons.length / columnSize)}>
					{this.renderCoupon(this.props.coupons)}
				</InnerBox>
				{showToast && this.renderToast()}
			</CouponContainer>
		);
	}
}

export default CouponCode;
